function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import ToolTip from '@airwallex/tooltip';
import React, { Fragment } from 'react';
import HelpText from '../helpText';
import Label from '../label';
import { ActionButton, Addon, IconInput, Input, InputHolder, InputWrapper, Link, Subtitle, RightAlignedText } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var NormalLabel = function NormalLabel(_ref) {
  var name = _ref.name,
      hideLabel = _ref.hideLabel,
      toolTip = _ref.toolTip,
      link = _ref.link,
      label = _ref.label,
      labelDirection = _ref.labelDirection,
      subtitle = _ref.subtitle;
  return ___EmotionJSX(Label, {
    id: name,
    hideLabel: hideLabel,
    labelDirection: labelDirection
  }, ___EmotionJSX("div", {
    style: {
      display: 'flex',
      justifyContent: 'space-between',
      flexGrow: 1
    }
  }, label, subtitle && ___EmotionJSX(Subtitle, {
    inline: true
  }, subtitle)), toolTip && ___EmotionJSX(ToolTip, {
    style: {
      marginLeft: 6
    },
    position: "top"
  }, toolTip), link && ___EmotionJSX(Link, {
    href: link.href,
    target: "_blank",
    rel: "noopener noreferrer",
    orange: link.orange
  }, link.text));
};
export var NormalTextInput = function NormalTextInput(_ref2) {
  var isFocused = _ref2.isFocused,
      isHoveredState = _ref2.isHoveredState,
      isErrored = _ref2.isErrored,
      isWarning = _ref2.isWarning,
      touched = _ref2.touched,
      innerClassName = _ref2.innerClassName,
      name = _ref2.name,
      icon = _ref2.icon,
      submitFailed = _ref2.submitFailed,
      placeholder = _ref2.placeholder,
      value = _ref2.value,
      onClickAction = _ref2.onClickAction,
      style = _ref2.style,
      actionButtonText = _ref2.actionButtonText,
      help = _ref2.help,
      error = _ref2.error,
      warning = _ref2.warning,
      onMouseOver = _ref2.onMouseOver,
      onMouseLeave = _ref2.onMouseLeave,
      isRtl = _ref2.isRtl,
      isLtr = _ref2.isLtr,
      addonBefore = _ref2.addonBefore,
      addonAfter = _ref2.addonAfter,
      rightAlignedText = _ref2.rightAlignedText,
      props = _objectWithoutProperties(_ref2, ["isFocused", "isHoveredState", "isErrored", "isWarning", "touched", "innerClassName", "name", "icon", "submitFailed", "placeholder", "value", "onClickAction", "style", "actionButtonText", "help", "error", "warning", "onMouseOver", "onMouseLeave", "isRtl", "isLtr", "addonBefore", "addonAfter", "rightAlignedText"]);

  return ___EmotionJSX(Fragment, null, ___EmotionJSX(InputWrapper, null, !!addonBefore && ___EmotionJSX(Addon, null, addonBefore), ___EmotionJSX(InputHolder, {
    isFocused: isFocused,
    isHovered: isHoveredState,
    isErrored: isErrored,
    isWarning: isWarning,
    isTouched: touched,
    className: innerClassName,
    addonBefore: addonBefore,
    addonAfter: addonAfter,
    isSubmitted: submitFailed
  }, !isRtl && ___EmotionJSX(IconInput, {
    icon: icon,
    isSubmitted: submitFailed
  }), ___EmotionJSX(Input, _extends({
    placeholder: placeholder,
    name: name,
    id: name,
    value: value,
    onMouseOver: onMouseOver,
    onMouseLeave: onMouseLeave,
    isSubmitted: submitFailed,
    style: style,
    isLtr: isLtr
  }, props)), isRtl && ___EmotionJSX(IconInput, {
    icon: icon,
    isSubmitted: submitFailed,
    isRtl: true
  }), onClickAction && ___EmotionJSX("div", null, ___EmotionJSX(ActionButton, {
    link: true,
    onClick: onClickAction
  }, actionButtonText)), rightAlignedText && ___EmotionJSX(RightAlignedText, null, rightAlignedText)), !!addonAfter && ___EmotionJSX(Addon, {
    after: true
  }, addonAfter)), ___EmotionJSX(HelpText, {
    text: help
  }), (touched || submitFailed) && (isErrored || isWarning) && ___EmotionJSX(HelpText, {
    text: error || warning,
    isErrored: isErrored,
    isWarning: isWarning,
    "data-test": "help_text_".concat(name)
  }));
};